import { Component, OnInit, Input } from "@angular/core";

@Component({
    selector: "dodo-radio-button",
    templateUrl: "./radio-button.component.html",
    styleUrls: ["./radio-button.component.scss"],
    standalone: false
})
export class RadioButtonComponent implements OnInit {
	@Input() settings: any;
	@Input() radio: any;
	constructor() {}

	ngOnInit() {}
}
